import React, { useState, useEffect, useContext } from "react";
import { Sec1, Sec2, Sec3, Sec4, Sec5, Sec6, Sec7, Sec8, Sec9, Sec10, Sec11 } from "./components/Homecomponent/index";
import CoreHttpHandler from "../http/services/CoreHttpHandler";
import { BlockUi } from "../reauseble";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { Container, Modal } from "react-bootstrap";

const Home = ({ show, ageModal, setAgeModal }) => {
	const [store, setStore] = useState([]);
	const [loading, setLoading] = useState(true);
	const [modalShow, setModalShow] = useState(true);
	const [bannerImg, setBannerImg] = useState("");
	const [bannerStatus, setBannerStatus] = useState(false);

	const getBannerImg = () => {
		CoreHttpHandler.request(
			"slider",
			"fetchSlides",
			{
				is_modal: true,
				id: 34,
			},
			(res) => {
				if (res?.data?.data?.slides) {

					setBannerImg(res?.data?.data?.slides[0]?.image)
					setBannerStatus(res?.data?.data?.slides[0]?.is_enabled)
				}
			},
			(err) => {
			}
		);
	};
	useEffect(() => {
		getBannerImg();
	}, []);
	// useEffect(() => {
	// 	if (!ageModal) {
	// 		ageValidations();
	// 	}
	// }, []);

	return (
		<>
			{/* <BlockUi show={show} /> */}
			<div id='home_main'>
				<div className='content_wrap'>

					<Sec1 />
					{/* <Sec2
						data={featuredProducts}
						loading={loading}
					/> */}
					{/* <Sec3 /> */}
					{/* <Sec4 show={show} /> */}
					{/* <Sec5 /> */}
					<Sec6 />
					{/* <Sec7 /> */}
					<Sec11 />
					<Sec8 />
					{/* <Sec9 />
					<Sec10 /> */}
					{bannerStatus && bannerImg &&
						<Modal
							centered
							// dialogClassName="modal-90w"
							show={modalShow}
							onHide={() => setModalShow(false)}
							aria-labelledby="contained-modal-title-vcenter">
							<Modal.Header closeButton>

							</Modal.Header>
							<Modal.Body>
								<Container>
									<img width="100%" src={bannerImg} />
								</Container>
							</Modal.Body>
						</Modal>
					}
				</div>
			</div>
		</>
	);
};

export default Home;
